export default __webpack_public_path__ + "static/siftingTchotchkes-c6a8f2319cebcaeb1c2e556aa71da812.svg";